/**
 * Injector de SVG en enlaces con clase yoyo-link
 * Añade una flecha decorativa a la derecha de los enlaces
 */
export default function initYoyoLinkArrow() {
    const arrowSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3333 4.16602C13.3333 4.78435 13.9442 5.70768 14.5625 6.48268C15.3575 7.48268 16.3075 8.35518 17.3967 9.02102C18.2133 9.52018 19.2033 9.99935 20 9.99935M20 9.99935C19.2033 9.99935 18.2125 10.4785 17.3967 10.9777C16.3075 11.6443 15.3575 12.5168 14.5625 13.5152C13.9442 14.291 13.3333 15.216 13.3333 15.8327M20 9.99935H0" stroke="currentColor"/>
</svg>`;

    const yoyoLinks = document.querySelectorAll('a.yoyo-link');
    
    yoyoLinks.forEach(link => {
        // No agregar si ya tiene el SVG (evitar duplicados)
        if (link.querySelector('svg')) return;
        
        // Crear contenedor para el SVG
        const arrowContainer = document.createElement('span');
        arrowContainer.className = 'yoyo-link__arrow';
        arrowContainer.innerHTML = arrowSvg;
        
        // Agregar el contenedor al final del link
        link.appendChild(arrowContainer);
    });
}
